const ChatIcon = ({
  className,
  onClick,
  style,
}: {
  className?: string;
  onClick?: any;
  style?: any;
}) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
      onClick={onClick}
    >
      <path
        d="M15.9 28C17.8086 28.9791 20.0041 29.2443 22.0909 28.7478C24.1777 28.2514 26.0186 27.0259 27.2818 25.2922C28.545 23.5586 29.1474 21.4308 28.9806 19.2922C28.8137 17.1537 27.8886 15.145 26.3718 13.6282C24.855 12.1115 22.8464 11.1863 20.7078 11.0195C18.5693 10.8526 16.4415 11.4551 14.7078 12.7183C12.9742 13.9815 11.7487 15.8224 11.2522 17.9092C10.7558 19.996 11.0209 22.1915 12 24.1L10 30L15.9 28Z"
        stroke="#663497"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChatIcon;
